import { DOCUMENT, KeyValue } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NotifierService } from 'angular-notifier';
import { MessageService } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';
import { DialogService } from '../../../../services/dialog.service';
import { ProgressSpinerService } from '../../../../services/progress-spiner.service';
import { ContractService } from '../service/contract.service';
import { saveAs as importedSaveAs } from "file-saver";

@Component({
  selector: 'app-bot-global-search',
  templateUrl: './bot-global-search.component.html',
  styleUrl: './bot-global-search.component.scss'
})
export class BotGlobalSearchComponent {

   myOptions!:object;
       bodySpinner:boolean=false;
          selectedDate:any;
          terminateDate:any;
          activeStep:number=1;
          questionsForm:FormGroup=new FormGroup({});
          rfpconfigFrom:FormGroup=new FormGroup({});
          excelSheetForm: FormGroup = new FormGroup({});
           sheetDataForm: FormGroup = new FormGroup({});
          rfpList:any[]=[];
          submitted:boolean=false;
          metricFullscreen:boolean=false;
          spinner:boolean=false;
          selectedRfp:number=0;
          listSearch:any;
          documentSearch:any;
          loading:boolean=true;
          documentListData:any[]=[];
          client_id:any;
          clientList:any[]=[];
          showUpdateButton:boolean=false;
          selectedRfPDetails:any;
          fileData:any;
           fileLLMformData: FormData = new FormData();
           uploadFileForm: FormGroup=new FormGroup({});
           uploadSelectFile:any[]=[];
           docSummary:any;
           selectedFilePreview:any;
           RFPDocPayLoad:any;
           pageNo:number=0;
           limit:number=25;
           total_records:number=0;
           total_pages:number=0;
           progressLoader:boolean=false;
            previewFileType:any;
         excelDataList:any[]=[];
          selectedCompanyId:any;
          companyListData:any[]=[];
           dropdownIndex: any;
           editTrainId:any;
           tabContent:any;
           showToolspopUp:boolean=false;
           @ViewChild("fileInput") fileInput!:ElementRef;
           @ViewChild("existModal") existModal!:ElementRef;
           @ViewChild('closebutton') closebutton!:ElementRef;
            @ViewChild('excelFile') excelFile!:ElementRef;
           /********Excel*********/
            title = 'excel-viewer';
    dataExcel: any = {};
    isFetched = false;
    stopFetching = false;
    eventEmitter = new BehaviorSubject<any>({});
    isEditing = false;
    sheetNames: string[] = ['Sheet1'];
           /********Excel********/
           previewDocFileName:any;
           previewDocId:any;  
             selectedDocuments: Set<string> = new Set();
             selectAll:boolean=false;
             botEnabled:boolean=false;
             currentUserDetail:any;
            uploadFiletype:any=null;
             showsheetform:boolean=false;
             sheetslist:any[]=[];
              sheetDetail:any={};
               document_details:any={};
               isModalVisible:boolean=false;
               seletedModal:any;
               popLoader:boolean=false;
            botQAList:any[]=[];
            botExpand:boolean=false;
            historySearch:any;
            historyPayload:any;
            historyTotalRecords:number=0;
            pinPayload:any; 
            botQAPinnedList:any[]=[];
            pinnedTotalRecords:number=0;
            selectedPinRecord:any={};
            isFileGenModalVisible:boolean=false;
            genFiletyleList:any={"filetype":[{"label":"Save as a word document","type":"docx"},{"label":"Save as a pdf","type":"pdf"}]};
            queryTypes:any[]=[{"label":"Private","type":"private"},{"label":"Generic","type":"public"}];
            botQAgenFile:any=null;
            botQAGenFilePayLoad:any;
            botQAFilespayload:any;
            botQAFileList:any[]=[];
            botFilesTotalRecords:number=0;
            botAudioFilesTotalRecords:number=0;
               urlSafe!: SafeResourceUrl;
               loader:boolean=false;
               botQAAudioFileList:any[]=[];
             queryType:any="private";
             documentsAllList:any[]=[];
             documentSection:any=null;
             selectAllDocument:boolean=false;
           private readonly notifier: NotifierService;
              constructor( private notifierService: NotifierService,private fb:FormBuilder,@Inject(DOCUMENT) private document:Document,private messageService: MessageService,private infosecService:ContractService,private sanitizer: DomSanitizer,private dialogService:DialogService,private ProgressLoader:ProgressSpinerService){
                 this.notifier = notifierService;
              }
        
        
          ngOnInit(){
           this.bodySpinner=true;
            
            this.questionsForm = this.fb.group({
              'questions':this.fb.array([])
            });
             this.rfpconfigFrom = this.fb.group({
              'client_id':[''],
             // 'company_id':['',Validators.required],
            'type_name':['',[Validators.required,Validators.pattern(/^[A-Za-z0-9\s\-\&]*$/)]],
            'description':['',[Validators.required,Validators.pattern(/^[A-Za-z0-9\s\-\'\&]*$/)]],
            'is_active':[true]
          });
      
          this.uploadFileForm = this.fb.group({
            'title':['',[Validators.required,Validators.pattern(/^[A-Za-z0-9\s\-\&]*$/)]]
          });
          this.excelSheetForm = this.fb.group({
           file_name: '',
           sheets: this.fb.array([]),
         });
      
          this.infosecService.getClient().subscribe(
            (response:any)=>{
               if(response.length > 0){
                   this.clientList = response;
                   //this.client_id=this.clientList[0]['id'];
                    if(this.clientList.length >0){
                       this.client_id=this.clientList[0]['id'];
                     this.rfpconfigFrom.controls['client_id'].setValue(this.client_id);
                     this.changeTobot();
                   }
               }
            },
            (error:HttpErrorResponse)=>{
      
            });
  
             this.getCompanyList();
       this.getRFPtypesList();
          
       
            // this.rfpList = [
            //     {
            //       "id":1,
            //       "name":"Service",
            //       "status":true
            //     },
            //     {
            //       "id":2,
            //       "name":"Product",
            //       "status":true
            //     }
            // ];
             this.documentListData = [
              
            ]; 
  
          this.infosecService.getCurrentUser().subscribe({
            next:(response:any)=>{
              this.currentUserDetail = response;
            },
            error:(errors:HttpErrorResponse)=>{}
          });  
         // this.documentSection="all";
    this.getAllDocumentsList();
       
this.botExpand=true;
this.botEnabled=true;
          // this.changeTobot();
           this.botExpand=true;
           
          }
        
          get questions(): FormArray {
            return this.questionsForm.get('questions') as FormArray;
          }
        
          // Method to create a new skill FormGroup
          newQuestion(): FormGroup {
            return this.fb.group({
              'question': ['', Validators.required]
              
            });
          }
        
          // Method to dynamically add a new skill
          addQuestion() {
            this.questions.push(this.newQuestion());
          }
        
          // Method to dynamically remove a skill at a specific index
          removeQuestion(i: number) {
            this.questions.removeAt(i);
          }
        
          getDateSearchData(event:any){
        
          }
        
          activateCallback(stepper:number){
            this.activeStep = stepper;
           }
        
          ngAfterViewInit(){
              setTimeout(()=>{
               this.loading=false;
              },3000);
            this.addQuestion();
            
               
          }
        
           selectStepper(step:number){
            this.activeStep = step;
           }
      
           selectedList(index:number){
            this.documentListData=[];
            this.pageNo=0;
            this.total_pages=0;
            this.selectedRfp = index;
            this.selectedRfPDetails = this.rfpList.filter(list=>list['id']==index)[0];
            this.pageNo++;
            this.selectedDocuments.clear();
            this.selectAll=false;
            this.getRFPDocuments();
           }
        
        
          show(stepper:any) {
            // this.activeStep = stepper;
              //  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Created Successfully', life: 3000 });
               this.notifier.notify('default', 'Created Successfully');
            }
      
            deleteRFP(idx:number){
               this.dialogService.openConfirmDialog('',{
              title: 'Confirm',
              message: 'Are you sure you want to delete this record?',
              btnOkText: 'Yes',
              btnCancelText: 'No',
              onClose: (data: any) => {
                if(data){
                  this.infosecService.deleteRFPtypes(idx).subscribe({
                  next:(response:any)=>{
                  this.notifier.notify('default', 'Deleted Successfully');
                 this.getRFPtypesList();
                  },
                  error:(errors:HttpErrorResponse)=>{
                    if(errors.error.errors=="404"){
                       this.notifier.notify('default', 'Cannot delete category is used');
                     }
                  }
                });
                }
              }
            });
         
             }
      
      
        
  
    getCompanyList(){
      this.infosecService.getCompanies().subscribe({
        next:(response:any)=>{
           this.companyListData = response['result'];
              this.bodySpinner = false;
              if(this.companyListData.length > 0){
                 this.selectedCompanyId = this.companyListData[0]['id'];
                
              }
        },
        error:(errors:HttpErrorResponse)=>{
           this.bodySpinner = false;
        }
      });
     }
  
     changeCompany(event:any){
     console.log(event.target.value)
       this.selectedCompanyId = event.target.value;
     }
      
        getRFPtypesList(){
          
             this.infosecService.getRFPtypesAll().subscribe(({
            next:(response:any)=>{
              this.bodySpinner=false;
               this.rfpList = response['result'];
               if(this.rfpList.length > 0){
                 this.selectedList(this.rfpList[0]['id']);
               }
            },
            error:(errors:HttpErrorResponse)=>{
          this.bodySpinner=false;
            }
          }));
          
         
        }
      
        saveRfp(){
          this.submitted=true;
          this.rfpconfigFrom.value['client_id'] = this.client_id
          this.rfpconfigFrom.markAllAsTouched();
          this.rfpconfigFrom.markAsDirty();
           if(this.rfpconfigFrom.valid){
            this.popLoader=true;
             this.infosecService.createRFPtypes(this.rfpconfigFrom.value).subscribe({
                next:(response:any)=>{
                  this.submitted=false;
                  this.isModalVisible=false;
                  this.rfpconfigFrom.reset();
                 this.notifier.notify('default', 'Category created successfully');
                 this.getRFPtypesList();
                },
                error:(errors:HttpErrorResponse)=>{
                  this.popLoader=false;
                    this.notifier.notify('default',errors.error['message']);
                }
              });
            }
        }
      
        editRFP(category:any){
              this.showUpdateButton = true;
              this.selectedRfp=category?.id;
              this.rfpconfigFrom.patchValue(category);
              this.OpenModal("category");
        }
      
        updateRFP(){
           this.submitted=true;
          this.rfpconfigFrom.value['client_id'] = this.client_id;
          this.rfpconfigFrom.markAllAsTouched();
          this.rfpconfigFrom.markAsDirty();
            if(this.rfpconfigFrom.valid){
              this.popLoader=true;
                this.infosecService.updateRFPtypes(this.rfpconfigFrom.value,this.selectedRfp).subscribe(({
                  next:(response:any)=>{
                    this.isModalVisible=false;
                     this.notifier.notify('default', 'Category updated successfully');
                      this.rfpconfigFrom.reset();
                      this.getRFPtypesList();
                     
                  },
                  error:(errors:HttpErrorResponse)=>{
                    this.popLoader=false;
                    this.notifier.notify('default',errors.error['message']);
                  }
                }));
            }
        }
      
        uploadPopup(){
          this.uploadSelectFile=[];
          this.uploadFileForm.reset();
          this.editTrainId=null;
          this.excelSheetForm.reset();
        }
      
        chooseUploadFile(event:any) {
          
          /* 
          const files = event.target.files;
            if (files[0].type == "application/pdf" || files[0].type=="text/plain" || files[0].type.indexOf("application/msword") != -1 || files[0].type.indexOf("application/vnd.openxmlformats") != -1 || files[0].type.indexOf("ms-excel") !=-1 || files[0].type.indexOf("application/vnd.openxmlformats-officedocument.wordprocessingml.document") !=-1) {
              
               const fileSizeInBytes = files[0].size;
          this.uploadSelectFile=files;
         console.log(files);
          console.log(`File size: ${fileSizeInBytes} bytes`);
      
          // Optional: Convert to KB or MB for better readability
          const fileSizeInKB = fileSizeInBytes / 1024;
          const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
          const fileSizeInGB = fileSizeInMB / (1024 * 1024 * 1024);
          console.log(`File size: ${fileSizeInKB.toFixed(2)} KB`);
          console.log(`File size: ${fileSizeInMB.toFixed(2)} MB`);
          console.log(`File size: ${fileSizeInGB.toFixed(2)} GB`);
          const file_gb = fileSizeInGB.toFixed(2);
          const size = file_gb.split(".")[1].substring(0, 1);
              this.fileLLMformData = new FormData();
              this.fileLLMformData.append('rfp_type_id',this.selectedRfp.toString());
               let d = new Date();
          var datestring = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + "_" +
            d.getHours()+"-"+d.getMinutes()+"-"+d.getSeconds();
              this.fileLLMformData.append('file', files[0], datestring+"_"+files[0].name);
           
            }else{
         
              this.notifier.notify('default', 'File format not support');
              this.fileInput.nativeElement.value="";
              this.uploadSelectFile=[];
              this.uploadFileForm.setErrors({'invaid':true});
              return;
            }*/
  
               const files = event.target.files;
         console.log('files',files);
          if (files[0].type == "application/pdf" || files[0].type.indexOf("application/msword") != -1 || files[0].type.indexOf("document")!=-1 && files[0].type.indexOf("spreadsheetml") == -1){
           
            this.uploadFiletype="doc";
     
          }else if(files[0].type.indexOf("spreadsheetml") != -1 || files[0].type.indexOf("ms-excel") !=-1) {
                 this.uploadFiletype="xls";
          }
         let fileLLMformData = new FormData();
          let d = new Date();
          var datestring = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + "_" +
            d.getHours()+"-"+d.getMinutes()+"-"+d.getSeconds();
         fileLLMformData.append('file', files[0], datestring+"_"+files[0].name);
         this.fileLLMformData.append('file', files[0], datestring+"_"+files[0].name);
         fileLLMformData.append('client_id',this.client_id);
          this.uploadSelectFile=files;
        // this.bodySpinner=true;
        this.popLoader=true;
         this.infosecService.uploadxls(fileLLMformData).subscribe({
           next:(response:any)=>{
          
           this.popLoader=false;
            if(this.uploadFiletype=="xls"){
              this.sheetslist=[];
                 this.sheetslist = response['sheets_names'];
              this.excelSheetForm.controls['file_name'].setValue(response['file_name']);
            // this.showDropdown = true;
           
             this.generateSheetForm();
             this.showsheetform = true;
            }
          
           },
           error:(errors:HttpErrorResponse)=>{
              this.bodySpinner=false;
              this.uploadSelectFile=[];
              
              if(errors.error['errors']==400){
                this.notifier.notify("default","Unsupported File Format");
              }
           }
         });
          }
      
        TrainRfp(){
           this.submitted=true;
           this.uploadFileForm.markAllAsTouched();
          this.uploadFileForm.markAsDirty();
          //  if(this.uploadFiletype==""){
          //    if(this.excelSheetForm.invalid){
          //       this.notifier.notify("default","Fill all required fields");
          //      return;
          //   }
          // }
             if(this.uploadFileForm.valid && this.uploadSelectFile.length > 0 && this.excelSheetForm.valid){
              this.submitted=false;
              this.popLoader=true;
              this.fileLLMformData.append('title',this.uploadFileForm.value['title']);
               this.fileLLMformData.append('client_id',this.selectedRfPDetails['client_id']);
               this.fileLLMformData.append("rfp_type_id",this.selectedRfp.toString());
              if(this.editTrainId!=null){
                this.fileLLMformData.append("doc_id",this.editTrainId);
              }
              this.fileLLMformData.append("sheet_details",JSON.stringify(this.excelSheetForm.value["sheets"]));
               this.progressLoader=true;
                if(this.editTrainId==null){
                  this.infosecService.trainRFPmodel(this.fileLLMformData).subscribe({
                    next:(response:any)=>{
                      // this.messageService.add({severity:'success',detail:response['message'],life:3000});
                         this.uploadSelectFile=[];  
                      //   let element =  document.getElementById("rfpTrain") as HTMLElement;
                      // element.className="modal fade rfpTrainFormModal";
                      // element.style.display="none";
                      // document.getElementsByClassName("modal-backdrop")[0].remove();
                      this.isModalVisible=false;
                      this.notifier.notify('default',"Trained Successfully");
                     
                      this.fileLLMformData=new FormData();
                      this.sheetslist=[];
                     this.excelSheetForm = this.fb.group({
                         file_name: '',
                       sheets: this.fb.array([]),
                       });
                       this.showsheetform=false;
                      this.progressLoader=false;
                      this.getRFPDocuments();
                    },
                    error:(errors:HttpErrorResponse)=>{
                    //  this.messageService.add({severity:'info',detail:errors['error']['message'],life:3000});
                    this.notifier.notify('default', errors.error['message']);
                      this.progressLoader=false;
                    }
                  });
                }else{
                  this.infosecService.updateTrainModel(this.fileLLMformData).subscribe({
                      next:(response:any)=>{
                       this.uploadSelectFile=[];  
                        let element =  document.getElementById("rfpTrain") as HTMLElement;
                      element.className="modal fade rfpTrainFormModal";
                      element.style.display="none";
                      document.getElementsByClassName("modal-backdrop")[0].remove();
                         this.notifier.notify('default',"Updated Successfully");
                       this.fileLLMformData=new FormData();
                      this.sheetslist=[];
                      this.excelSheetForm = this.fb.group({
                          file_name: '',
                           sheets: this.fb.array([]),
                      });
                       this.showsheetform=false;
                      this.progressLoader=false;
                      this.getRFPDocuments();
                      },
                    error:(errors:HttpErrorResponse)=>{
                    //  this.messageService.add({severity:'info',detail:errors['error']['message'],life:3000});
                    this.notifier.notify('default', errors.error['message']);
                      this.progressLoader=false;
                    }
                  });
                }
             
             }
             
        }
      
        getRFPDocuments(){
          this.RFPDocPayLoad ={
            "page":this.pageNo,
          "limit":this.limit,
          "filters": [
              {
                  "property": "rfp_type_id",
                  "operator": "eq",
                  "value": this.selectedRfp
              }
          ]
          }
          this.loading=true;
          this.bodySpinner=true;
          this.infosecService.getRFPDocuments(this.RFPDocPayLoad).subscribe({
            next:(response:any)=>{
               this.bodySpinner=false;
              if(this.pageNo==1){
                 this.documentListData = response['data'].length > 0 ? response['data'] : [];
              }else{
                if(response['data'].length > 0){
                  this.documentListData = [...this.documentListData,...response['data']];
                }
                
              }
              
              this.total_records = response['pagination']['total'];
              this.total_pages = response['pagination']['total_pages'];
               this.loading=false;
               this.selectAll=true;
               this.toggleSelectAll('single');
            },
            error:(errors:HttpErrorResponse)=>{
               this.bodySpinner=false;
              this.documentListData=[];
               this.loading=false;
            }
          });
          
        }
      
        showSummary(document:any){
          this.spinner=false;
          this.docSummary="";
          this.docSummary = document['metadata']['summary'];
        }
      
        newCategory(modal:any){
          this.submitted=false;
          this.seletedModal=modal;
          this.isModalVisible = true;
        }
        exitIconReset(){
          this.docSummary="";
           this.selectedFilePreview="";
           this.uploadSelectFile=[];
           this.editTrainId=null;
           this.previewDocFileName="";
           this.previewDocId="";
           this.rfpconfigFrom.reset();
           this.isModalVisible=false;
           this.urlSafe="";
        }
      
        previewFile(document:any){
            this.selectedFilePreview="";
         // this.bodySpinner=true;
            this.urlSafe="";
          this.spinner=true;
           this.metricFullscreen=true;
             this.previewFileType = document['doc_type'];
             this.previewDocFileName = document['doc_name'];
             this.previewDocId = document['id'];
      this.excelDataList=[];
      if(this.previewFileType =="xls" || this.previewFileType =="xlsx"){
        this.infosecService.getSheetsPrview(document['id']).subscribe({
            next:(response:any)=>{
             // console.log("res",response);
             this.document_details["type"]="trained";
              if(document['sheet_details']!=null){
                console.log(document['sheet_details']);
                  this.sheetDetail = {
                    "file_name":this.previewDocFileName,
                    "sheets":document['sheet_details']
                  };
                 }else{   
                   this.sheetDetail = {"file_name":this.previewDocFileName,
                    "sheets":[{"sheet_name":"Sheet1","question_column":"a","answer_column":"b","starting_row":2,"comments_column":"","attachment_column":""}]
                  };
                 }
  
           this.dataExcel = response;
               console.log("res",response);
              if (Array.isArray(response)){
                   this.excelDataList = response;
              }else{
                if(Object.keys(response)){
                  let key =  Object.keys(response)[0];
                  this.excelDataList = response[key];
                } 
              }
              this.bodySpinner=false;
               this.spinner=false;
            },
            error:(errors:HttpErrorResponse)=>{
             this.bodySpinner=false;
              this.spinner=false;
            }
          });
         
      }else{
         this.urlSafe="";
        this.infosecService.getDocumentPreview(document['id']).subscribe({
          next:(response:any)=>{
          
           this.spinner = true;
                this.blobToBase64(response).then((res:any) => {
    // do what you wanna do
              this.urlSafe=res;
              this.spinner = false;
              
          }); 
          },
          error:(errors:HttpErrorResponse)=>{}
        });
     
       
         this.bodySpinner=false;
         this.spinner=false;
      }
            
        }
      
        viewDocumentFromBlob(blob: Blob) {
          // Create a blob URL
         // const pdfBlob = new Blob([blob], { type: 'application/pdf' });
      
       ///const objectUrl = URL.createObjectURL(pdfBlob);
          const objectUrl = URL.createObjectURL(blob);
          // Sanitize the URL before passing to ngx-doc-viewer
           this.spinner = false;
          this.selectedFilePreview = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
        }
      
        deleteDocument(document:any){
          this.dialogService.openConfirmDialog('',{
              title: 'Delete Document',
              message: 'Do you want to delete the file?',
              btnOkText: 'Yes',
              btnCancelText: 'No',
              onClose: (data: any) => {
                if (data) {
                  this.infosecService.deleteTrainedDocument(document['id']).subscribe({
                   next:(response:any)=>{
                    this.getRFPDocuments();
                      // this.messageService.add({severity:'success',detail:'Document deleted successfully',life:3000});
                       this.notifier.notify('default', 'Document deleted successfully');
                   },
                  error:(erors:HttpErrorResponse)=>{}
                  });
                }
             }});
          
        }
      
        contentLoaded(){
      
        }
      
        onNearEndScroll(){
            console.log("nearend");
           if(this.pageNo  < this.total_pages){
            this.pageNo++;
            this.getRFPDocuments();
           }
           
        }
      
       
      
         pageChanged(event: any) {
            this.pageNo = event;
         }
  
         keepOrder(x: KeyValue<string, any>, y: KeyValue<string, any>): number  {
                   return 1;
               }
      
        //  onTableScroll(event: any): void {
        //   const scrollTop = event.target.scrollTop;
        //   const scrollHeight = event.target.scrollHeight;
        //   const offsetHeight = event.target.offsetHeight;
      
        //   if (scrollHeight - (scrollTop + offsetHeight) < 50 && !this.loading) {
        //      console.log("more");
        //   }
        // }
  
      clickit($event:any, ind:any) {
      $event.stopPropagation();
  
      // Reset upward position if switching to a different dropdown
      if (this.dropdownIndex !== ind) {
       // this.dropdownUpIndex = -1;
      }
  
      this.dropdownIndex = ind;
      // this.show = !this.show;
  
      // // Check if dropdown should open upward
      // if (this.show) {
      //   // Use requestAnimationFrame to ensure DOM is updated
      //   requestAnimationFrame(() => {
      //     setTimeout(() => {
      //       this.checkDropdownPosition($event.target, ind);
      //     }, 10);
      //   });
      // } else {
      //   this.dropdownUpIndex = -1;
      // }
    }
  
   // dropdownUpIndex: number = -1; // Track which dropdown should open upward
  
    checkDropdownPosition(triggerElement: any, index: number) {
      // Find the dropdown container
      const dropdownContainer = triggerElement.closest('.dropdown');
      if (!dropdownContainer) return;
  
      const dropdownMenu = dropdownContainer.querySelector('.dropdown-menu');
      if (!dropdownMenu) return;
  
      const trigger = dropdownContainer.querySelector('.dropdown-trigger');
      if (!trigger) return;
  
      const triggerRect = trigger.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
  
      // Get actual dropdown height if available, otherwise estimate
      const dropdownRect = dropdownMenu.getBoundingClientRect();
      const dropdownHeight = dropdownRect.height > 0 ? dropdownRect.height : 250;
  
      // Check if dropdown would be cut off at the bottom
      const spaceBelow = viewportHeight - triggerRect.bottom;
  
      // If not enough space below, open upward (with 10px buffer)
      if (spaceBelow < dropdownHeight + 10) {
       // this.dropdownUpIndex = index;
      } else {
        //this.dropdownUpIndex = -1;
      }
    }
  
    downloadFile(document:any){
            let id=document['id'];
           this.infosecService.savefileDownload(id).subscribe({
             next:(response:any)=>{
             let d = new Date();
               var datestring = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + "_" +
                 d.getHours();
                 let doc_title = document?.title;
               importedSaveAs(response,doc_title+"_"+datestring + document['doc_type']);
                this.notifier.notify('default','File download successfully');
             },
             error:(errors:HttpErrorResponse)=>{
              this.notifier.notify('default', errors.error['message']);
             }
           });
        
    }
  
  
  
    EditTraine(document:any){
      this.submitted=false;
     // this.OpenModal("trainai");
       this.uploadSelectFile=[];
       this.uploadFileForm.reset();
       this.editTrainId=null;
        this.excelSheetForm.reset();
      this.editTrainId=document['id'];
      this.uploadFileForm.controls['title'].setValue(document['title']);
       this.seletedModal="trainai";
      this.submitted=false;
      this.isModalVisible = true;
      this.popLoader=false;
  
    }
  
     onScrollExcel(event: any): void {
     
    }
  
    handleSave(){
      this.eventEmitter.next({id: "Source", type: "save"});
      this.isEditing = false;
    }
  
    handleCancel(){
      this.eventEmitter.next({id: "Source", type: "cancel"});
      this.isEditing = false;
    }
  
    onSave(event: any){
      console.log(event);
      event["doc_id"]=this.previewDocId;
      event["file_name"]=this.previewDocFileName;
      event["client_id"]=this.client_id;
      if(event["action"]=="updateTrain"){
           this.infosecService.editExcelTrain(event).subscribe(({
        next:(response:any)=>{
          this.getRFPDocuments();
           this.notifier.notify('default',"Train AI Updated Successfully");
        },
        error:(errors:HttpErrorResponse)=>{
          this.notifier.notify("default","Unable to train AI");
        }
      }));
      }
    
    }
  
  
  
    isDocumentSelected(document: any): boolean {
         const id = document['metadata'].document_id;
         return this.selectedDocuments.has(id);
    }
  
  
     toggleDocumentSelection(document: any) {
         const id = document['metadata'].document_id;
     
         
     
         if(id){
            if (this.selectedDocuments.has(id)) {
           this.selectedDocuments.delete(id);
           } else {
             this.selectedDocuments.add(id);
           }
         }
        
         //this.updateSelectAllState();
    }
  
      toggleSelectAll(section:any) {
        this.documentSection=section;
        if(this.documentSection=="all"){
           this.selectAll=false;
          if(this.selectAllDocument){
             this.selectedDocuments.clear();
              this.documentsAllList.forEach(doc => {
              const id = doc['metadata'].document_id;
               if(id){
                  this.selectedDocuments.add(id);
               }
            });
          }else{
            
          }
         // this.selectAllDocument = !this.selectAllDocument;
         
          
        }else  if(this.documentSection=="single"){
          this.selectAllDocument = false;
           if (this.selectAll) {
           this.selectedDocuments.clear();
             this.documentListData.forEach(doc => {
              
               const id = doc['metadata'].document_id;
               if(id){
                  this.selectedDocuments.add(id);
               }
            });
         } else {
           this.documentListData.forEach(doc => {
              
               const id = doc['metadata'].document_id;
               if(id){
                  this.selectedDocuments.add(id);
               }
            });
         }
        // this.selectAll = !this.selectAll;
        }
        
       }
  
  
  
        generateSheetForm() {
          if(this.sheetslist.length > 0){
            this.sheetslist.forEach((data:any,index)=>{
               this.addSheets();
             this.Sheets.controls[index].get('sheet_name')?.setValue(data);
            })
          }
        //  let i = 0;
     
        //  while (i < this.sheetslist.length) {
        //   if(this.sheetslist[i]){
        //    this.addSheets();
        //    this.Sheets.controls[i].get('sheet_name')?.setValue(this.sheetslist[i]);
        //   }
         
        //    i++;
        //  }
     
       }
     
       get Sheets() {
         return this.excelSheetForm.get("sheets") as FormArray;
       }
     
       get sheetlist() {
         return this.sheetDataForm.get('sheet_list') as FormArray;
       }
     
     
     
       newSheet(): FormGroup {
         return this.fb.group({
           sheet_name: ['', Validators.required],
           question_column: ['', Validators.required],
            answer_column: ['', Validators.required],
            starting_row:[1,Validators.required],
            comments_column:[''],
            attachment_column:['']
  
         })
       }
     
       addSheets() {
         this.Sheets.push(this.newSheet());
       }
     
       removeSheet(i: number) {
         
               this.Sheets.removeAt(i);
               if (this.Sheets.controls.length == 0) {
                 this.showsheetform = false;
                 this.uploadSelectFile=[];
               
                   this.fileLLMformData.delete("file");
               }
             
       }
     
      OpenModal(modal:any){
       this.seletedModal=modal;
       if(modal=="trainai"){
        this.uploadPopup();
       }
      this.submitted=false;
      this.isModalVisible = true;
      this.popLoader=false;
      } 
  
      changeTobot(){
       
       
        if(this.botEnabled){
          this.queryType="private";
          this.botQAList=[];
        
          this.pageNo=1;
          this.limit=25;
          this.historyPayload = {
            "client_id":this.client_id,
            "page":this.pageNo,
            "limit":this.limit,
            "filters":[
              {
            "property": "is_global",
            "operator": "eq",
            "value": true
        }
            ]
          }
          this.pinPayload = {   
          "client_id":this.client_id,
          "page":this.pageNo,
          "limit":this.limit,
          "filters": [
              {
                  "property": "is_pinned",
                  "operator": "eq",
                  "value": true
              },
              {
            "property": "is_global",
            "operator": "eq",
            "value": true
        }     
           ]
          }
          this.getBotQueryAll();
          this.getBotQueryPinAll();
        }
      }
  
      expandBot(){
           this.botExpand = !this.botExpand; 
      }
  
  
      searchQuery(data:any){
      
       
        if(data['tags'].length==0  && data['data']==""){
          this.notifier.notify("default","Enter your question");
          return;
        }
  
         if(this.selectedDocuments.size==0 && this.queryType=="private"){
          this.notifier.notify("default","No documents in "+this.selectedRfPDetails?.type_name);
          return;
        }
        if(data['data'].trim() !=""){
          data['tags'].push(data['data']);
        }
  
      let payLoad:any;
  
        if(this.queryType=="private"){
          payLoad ={
                "document_id":Array.from(this.selectedDocuments).toString(),
                "question":data['tags'],
                "mode":"answer",
                "client_id":this.client_id,
                "category_id":this.selectedRfp,
                "query_type":this.queryType,
                "is_global":true
              }
        }else{
          payLoad ={
          "question":data['tags'],
          "client_id":this.client_id,
           "query_type":this.queryType,
           "is_global":true
           }
        }
      
        //this.bodySpinner=true;
        this.ProgressLoader.showLoader('',{loaderMessage:"In-Progress"});
        this.infosecService.searchBotQuery(payLoad).subscribe({
          next:(response:any)=>{
           // this.bodySpinner=false;
            this.ProgressLoader.closeLoader();
            this.botQAList = [...response,...this.botQAList];
            
          },
          error:(errors:HttpErrorResponse)=>{
           // this.bodySpinner=false;
           this.ProgressLoader.closeLoader();
          }
        });
      }
  
  
      getBotQueryAll(){
         this.spinner=true;
          this.infosecService.getBotQueryAll(this.historyPayload).subscribe({
          next:(response:any)=>{
            this.spinner=false;
              if(response['data'].length > 0){
                this.historyTotalRecords=response['pagination']['total_records'];
                if(this.historyPayload['page']==1){
                  this.botQAList = response['data'];
                }else{
                 this.botQAList = [...this.botQAList,...response['data']];
                }
              }
          },
          error:(errors:HttpErrorResponse)=>{
             this.spinner=false;
          }
         });
      }
      onScrollBotQuery(){
        if(this.historyTotalRecords > this.botQAList.length){
           this.historyPayload['page'] = this.historyPayload['page']+1;
           this.getBotQueryAll();
        }
      }
  
      showTools(content:any){
        
        this.tabContent=content;
        if(content){
          this.showToolspopUp=true;
        }else{
          this.showToolspopUp=false;
        }
        if(content=="pin"){
          if(this.botQAPinnedList.length > 0){
            this.selectedPinRecord=this.botQAPinnedList[0];
          }
        }
  
        if(content=="files"){
          this.pageNo = 1;
          this.getBotQueryFiles();
        }
        if(content=="audio"){
          this.pageNo = 1;
           this.botQAFilespayload =  {   
            "client_id":this.client_id,
            "page": this.pageNo,
            "limit": this.limit,
            "filters": [
                {
                    "property": "is_mp3",
                    "operator": "eq",
                    "value": true
                },
              {
            "property": "is_global",
            "operator": "eq",
            "value": true
        }]
          }
  
          this.getBotQueryAudioFiles();
        }
  
  
  
      }
  
      deleteQuery(list:any){
         let qId = list['qid'];
          this.dialogService.openConfirmDialog('',{
              title: 'Confirm',
              message: 'Are you sure you want to delete this record?',
              btnOkText: 'Yes',
              btnCancelText: 'No',
              onClose: (data: any) => {
                if(data){
                //this.ProgressLoader.showLoader('',{loaderMessage:"Progress"});
                this.infosecService.botQueryDelete(qId).subscribe({
                    next:(response:any)=>{
                     // this.ProgressLoader.closeLoader();
                      let index = this.botQAList.findIndex((list:any)=>list['qid']==qId);
                      if(index !=-1){
                         this.botQAList.splice(index,1);
                         this.notifier.notify("default","Deleted Successfully");
                      }
                    },
                    error:(errors:HttpErrorResponse)=>{
                     // this.ProgressLoader.closeLoader();
                    }
                });
              }
             }});
      }
  
      botToolsAction(data:any){
        let qid = data['qid'];
          if(data['action']=="pin"){
             this.infosecService.botQueryPin(qid).subscribe({
              next:(response:any)=>{
                 let index = this.botQAList.findIndex((list:any)=>list['qid']==qid);
                if(index !=-1){
                  this.botQAList[index]['is_pinned']=true;
                  this.botQAPinnedList.unshift(this.botQAList[index]);
                }
                 this.notifier.notify("default","Pinned Successfully");
              },
              error:(errors:HttpErrorResponse)=>{}
             });
          }else if(data['action']=="file"){
            this.isFileGenModalVisible=true;
            this.botQAgenFile=null;
            this.botQAGenFilePayLoad = {
              "client_id":this.client_id,
              "qid":qid,
             };
         }else if(data['action']=="audio"){
          this.botQAGenFilePayLoad = {
              "client_id":this.client_id,
              "qid":qid,
              "is_mp3":true
             };
              this.infosecService.botQueryGenfile(this.botQAGenFilePayLoad).subscribe({
              next:(response:any)=>{
                this.notifier.notify("default","File generated successfully");
              },
              error:(errors:HttpErrorResponse)=>{}
             });
         }else if(data['action']=="comment"){
  
            data['client_id'] = this.client_id
            this.infosecService.botQueryComment(data).subscribe({
              next:(response:any)=>{
                this.notifier.notify("default","Your comment posted successfully");
              },
              error:(errors:HttpErrorResponse)=>{}
            });
  
         }
      }
  
      getBotQueryPinAll(){
         
         this.infosecService.getBotQueryPinAll(this.pinPayload).subscribe({
          next:(response:any)=>{
              if(response['data'].length > 0){
                this.pinnedTotalRecords=response['pagination']['total_records'];
                if(this.pinPayload['page']==1){
                  this.botQAPinnedList = response['data'];
                }else{
                 this.botQAPinnedList = [...this.botQAPinnedList,...response['data']];
                }
              }
            },
          error:(errors:HttpErrorResponse)=>{
  
          }
         });
   
      }
  
       onScrollPinned(){
        if(this.pinnedTotalRecords > this.botQAPinnedList.length){
           this.pinPayload['page'] = this.pinPayload['page']+1;
           this.getBotQueryPinAll();
        }
      }
  
  
      unPinnedQuery(item:any){
        let qid = item['qid'];
         this.dialogService.openConfirmDialog('',{
              title: 'Confirm',
              message: 'Are you sure you want to UnPin this record?',
              btnOkText: 'Yes',
              btnCancelText: 'No',
              onClose: (data: any) => {
                if(data){
                   this.infosecService.botQueryUnPin(qid).subscribe({
                    next:(response:any)=>{
                      let index = this.botQAPinnedList.findIndex((list:any)=>list['qid']==qid);
                      if(index !=-1){
                        this.botQAPinnedList.splice(index,1);
                        let unPinindex = this.botQAList.findIndex((list:any)=>list['qid']==qid);
                        if(unPinindex !=-1){
                          this.botQAList[unPinindex]['is_pinned']=false;
                        }
                        this.notifier.notify("default","Unpinned Successfully");
                        if(this.botQAPinnedList.length > 0){
                          this.selectedPinRecord = this.botQAPinnedList[0];
                        }else{
                          this.selectedPinRecord="";
                        }
                      }
                    },
                    error:(errors:HttpErrorResponse)=>{}
                   });
                }
        }})  
      }
  
      gotoBotQA(questionId:any){
        this.showToolspopUp=false;
        this.tabContent='';
          var isScrolling:any;
      setTimeout(() => {
        const element = document.getElementById('question' + questionId);
        element?.scrollIntoView({ behavior: 'smooth' });
        document.getElementsByClassName("internalBodyTwo")[0].scrollTop=0;
        (this.document.getElementById("chat-list-content") as HTMLElement).addEventListener("scroll", (ev: any) => {
          // Clear our timeout throughout the scroll
         window.clearTimeout(isScrolling);
          // Set a timeout to run after scrolling ends
          isScrolling = setTimeout(function () {
            document.getElementsByClassName("internalBodyTwo")[0].scrollTop=0;
            // Run the callback
  
          }, 100);
        });
      }, 10); 
      }
  
      getBotQueryFiles(){
          this.botQAFilespayload =  {   
      "client_id":this.client_id,
      "page": this.pageNo,
      "limit": this.limit,
      "filters": [
        {
            "property": "is_global",
            "operator": "eq",
            "value": true
        },
          {
              "property": "is_docx",
              "operator": "eq",
              "value": true
          },
           {
              "property": "is_pdf",
              "operator": "eq",
              "value": true
          }
      ]
  }
  
         this.infosecService.getBotQueryAll(this.botQAFilespayload).subscribe({
          next:(response:any)=>{
            this.botQAFileList = response['data'];
  
            if(response['data'].length > 0){
                this.botFilesTotalRecords=response['pagination']['total_records'];
                if(this.pinPayload['page']==1){
                  this.botQAFileList = response['data'];
                
                  this.showQABotfile(this.botQAFileList[0],0);
                }else{
                 this.botQAFileList = [...response['data'],...this.botQAFileList];
                }
              }
          },
          error:(errors:HttpErrorResponse)=>{}
         });
      }
   onScrollGenFiles(){
    if(this.tabContent=="files"){
       if(this.botFilesTotalRecords > this.botQAFileList.length){
           this.botQAFilespayload['page'] = this.botQAFilespayload['page']+1;
           this.getBotQueryFiles();
        }
    }
  
    if(this.tabContent=="audio"){
       if(this.botAudioFilesTotalRecords > this.botQAAudioFileList.length){
         this.botQAFilespayload['page'] = this.botQAFilespayload['page']+1;
         this.getBotQueryAudioFiles();
       }
    }
      
   }
  
   getBotQueryAudioFiles(){
         this.infosecService.getBotQueryAll(this.botQAFilespayload).subscribe({
          next:(response:any)=>{
            
  
            if(response['data'].length > 0){
                this.botFilesTotalRecords=response['pagination']['total_records'];
                if(this.botQAFilespayload['page']==1){
                  this.botQAAudioFileList = response['data'];
                
                  this.showQABotfile(this.botQAAudioFileList[0],0);
                }else{
                 this.botQAAudioFileList = [...response['data'],...this.botQAAudioFileList];
                }
              }
          },
          error:(errors:HttpErrorResponse)=>{}
         });
   }
  
      selectFileType(data:any){
        this.botQAgenFile=data;
      }
     genFileTypeSubmit(){
       if(this.botQAgenFile !=null){
        if(this.botQAgenFile=="docx"){
           this.botQAGenFilePayLoad['is_docx'] = true;
        }else if(this.botQAgenFile=="pdf"){
           this.botQAGenFilePayLoad['is_pdf'] = true;
        }
         
  
            this.infosecService.botQueryGenfile(this.botQAGenFilePayLoad).subscribe({
              next:(response:any)=>{
                this.isFileGenModalVisible=false;
                this.notifier.notify("default","File generated successfully");
              },
              error:(errors:HttpErrorResponse)=>{}
             });
       }
              
     }
  
     showQABotfile(data:any,index:any){
         let payload = {
          "client_id":this.client_id,
          "qid":data['qid'],
          "doc_type":data['doc_type'] =='mp3'? "mp3" :"pdf"
  
         };
           this.selectedPinRecord['select_index']=index;
         this.loader=true;
         this.infosecService.botQueryFilePreview(payload).subscribe({
          next:(response:any)=>{
            this.urlSafe="";
            this.blobToBase64(response).then((res:any) => {
             
               this.urlSafe=res;
                this.loader=false;
              }); 
          },
          error:(errors:HttpErrorResponse)=>{
            this.loader=false;
          }
         });
     }
  
  
  
  
  
     blobToBase64(blob:any){
      
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise((resolve,reject) => {
      reader.onloadend = () => {
       
        resolve(reader.result);
      };
    });
   }
  
   removeFile(item:any){
     let payload = {
      "qid":item['qid'],
      "doc_type":item['doc_type']
     }
      this.dialogService.openConfirmDialog('',{
              title: 'Confirm',
              message: 'Are you sure you want to delete this record?',
              btnOkText: 'Yes',
              btnCancelText: 'No',
              onClose: (data: any) => {
                if(data){
                this.infosecService.botQueryFileDelete(payload).subscribe({
                  next:(response:any)=>{
                    this.notifier.notify("default","Deleted Successfully");
                    if(this.tabContent=="files"){
                       let index = this.botQAFileList.findIndex((list:any)=>list['qid']==item['qid']);
                      if(index!=-1){
                         this.botQAFileList.splice(index,1);
                      }
                    }
                    if(this.tabContent=="audio"){
                        let index = this.botQAAudioFileList.findIndex((list:any)=>list['qid']==item['qid']);
                      if(index!=-1){
                         this.botQAAudioFileList.splice(index,1);
                         if(this.botQAAudioFileList.length==0){
                          this.urlSafe="";
                         }
                      }
                    }
                    
                  },
                  error:(errors:HttpErrorResponse)=>{
  
                  }
                });
              }
            }}); 
   }
  
   downloadfile(item:any){
     let payload = {
          "client_id":this.client_id,
          "qid":item['qid'],
          "doc_type":item['doc_type']
  
         };
         
       
         this.infosecService.botQueryFilePreview(payload).subscribe({
          next:(response:any)=>{
             let d = new Date();
               var datestring = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + "_" +
                 d.getHours();
                 let doc_title = document?.title;
               importedSaveAs(response,doc_title+"_"+datestring +"."+ item['doc_type']);
                this.notifier.notify('default','File download successfully');
          },
          error:(errors:HttpErrorResponse)=>{
            
          }
         });
   }
  
  selectQueryType(type:any){
    this.queryType=type;
  }
  
   getAllDocumentsList(){
     this.documentsAllList=[];
      let PayLoad = {
            "page":1,
            "per_page":1000,
            "filters": []
          }
          
          this.infosecService.getRFPDocuments(PayLoad).subscribe({
            next:(response:any)=>{
                 this.documentsAllList = response['data'].length > 0 ? response['data'] : [];
                   this.selectedDocuments.clear();
                   if(this.documentsAllList.length > 0){
                       this.selectAllDocument=true;
                       this.toggleSelectAll('all');
                   }
                
            },
            error:(errors:HttpErrorResponse)=>{
                 this.documentsAllList=[];
               
            }
          });
   }
  
   selectDocSection(section:any){
     this.documentSection= section;
   }

}
 

